import type { VendorMetadataExtractor, ExtractedIncidentMeta } from './types'
import { scanFileForGprmc } from './nmea'

export const viofoExtractor: VendorMetadataExtractor = {
  vendorId: 'viofo',
  vendorLabel: 'VIOFO',
  supportsDirectoryBrowse: false,

  async extractFromFiles(files: File[]): Promise<ExtractedIncidentMeta | null> {
    // VIOFO uses Novatek chipsets which embed GPS data in custom MP4 `free` boxes.
    // Those boxes contain NMEA-like strings readable by a binary scan.
    // Note: success rate is lower than BlackVue; GPS blocks may appear later in the file.
    const videoFile = files.find((f) => f.type.startsWith('video/') || f.name.endsWith('.mp4'))
    if (!videoFile) return { dateTime: new Date(files[0]?.lastModified) }

    // Scan a larger chunk because Novatek GPS blocks may not be in the very first bytes
    const result = await scanFileForGprmc(videoFile, 524288) // 512 KB
    if (!result) return { dateTime: new Date(videoFile.lastModified) }

    return {
      dateTime: result.dateTime,
      lat: result.lat,
      lon: result.lon
    }
  }
}
